import { config } from './../config'
import { LocationService } from './../services/location.service'
import { SeoService } from './../services/seo.service'
import { Apollo } from 'apollo-angular'
import { Component, OnInit } from '@angular/core'
import gql from 'graphql-tag'
import { AnalyticsService } from '../services/analytics.service'

@Component({
  selector: 'app-org',
  templateUrl: './org.component.html',
  styleUrls: ['./org.component.scss']
})
export class OrgComponent implements OnInit {
  org: any

  constructor(
    private apollo: Apollo,
    private analytics: AnalyticsService,
    private seo: SeoService,
    private location: LocationService
  ) {}

  async getOrg(variables: any) {
    try {
      const { data, errors } = await this.apollo
        .query({
          query: gql`
            query Pages_GetOrg($org: String) {
              getOrg(slug: $org) {
                id
                slug
                name
                appSettings {
                  themeColor
                }
              }
            }
          `,
          variables
        })
        .toPromise()

      this.org = data && data['getOrg']

      if (this.org) {
        this.seo.set({
          title: this.org.name,
          description: this.org.description,
          url: this.location.getCanonical(),
          image: this.seo.getPreviewImage(this.org.slug)
        })

        this.analytics.setContext({
          orgId: this.org.id
        })
      }

      if (errors) {
        console.log('errors', errors)
      }
    } catch (err) {
      console.log(err)
    }
  }

  ngOnInit() {
    const { org } = config
    this.getOrg({ org })

    this.seo.set({ title: org })
  }
}
